import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { DaysToDeliveryFieldsNames } from "globalConstants";
import { float2Normalizer } from "validators";
import {
	maxValue100,
	minValueDays,
	onlyDigits,
	onlyPercent,
	required,
	validateDaysToDelivery,
} from "validators/validation";

import styles from "./daysToDelivery.module.scss";

type DaysToDeliveryFieldsProps = {
	isLoading: boolean;
	handleUpdateValue: Function;
};

const {
	SameDay,
	OneThreeDays,
	FourSevenDays,
	EightFourteenDays,
	FifteenThirtyDays,
	ThirtyPlusDays,
	DaysOverThirty,
} = DaysToDeliveryFieldsNames;

export const DaysToDeliveryFieldsForCreditReviewExposureCalculator = ({
	isLoading,
	handleUpdateValue,
}: DaysToDeliveryFieldsProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<>
			<Row>
				<Col md={6}>
					<HookFormInputGroup
						name={SameDay.name}
						register={register}
						label={`${SameDay.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.00"
						showRequiredMark
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						className={styles.inputGroup}
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						onBlur={handleUpdateValue}
						errors={errors}
					/>
				</Col>
				<Col md={6}>
					<HookFormInputGroup
						name={OneThreeDays.name}
						register={register}
						label={`${OneThreeDays.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.00"
						showRequiredMark
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						className={styles.inputGroup}
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						onBlur={handleUpdateValue}
						errors={errors}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={6}>
					<HookFormInputGroup
						name={FourSevenDays.name}
						register={register}
						label={`${FourSevenDays.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.00"
						showRequiredMark
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						className={styles.inputGroup}
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						onBlur={handleUpdateValue}
						errors={errors}
					/>
				</Col>
				<Col md={6}>
					<HookFormInputGroup
						name={EightFourteenDays.name}
						register={register}
						label={`${EightFourteenDays.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.00"
						showRequiredMark
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						onBlur={handleUpdateValue}
						className={styles.inputGroup}
						errors={errors}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={6}>
					<HookFormInputGroup
						name={FifteenThirtyDays.name}
						register={register}
						label={`${FifteenThirtyDays.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder="0.00"
						showRequiredMark
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						className={styles.inputGroup}
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						onBlur={handleUpdateValue}
						errors={errors}
					/>
				</Col>
				<Col md={6}>
					<HookFormInputGroup
						name={DaysOverThirty.name}
						register={register}
						label={`${DaysOverThirty.displayName}, %`}
						colInput={6}
						colLabel={4}
						blurLoading={isLoading}
						autoComplete="off"
						showRequiredMark
						validator={{ required, minValueDays }}
						normalize={onlyDigits}
						className={styles.inputGroup}
						onBlur={handleUpdateValue}
						errors={errors}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={{ span: 6, offset: 6 }}>
					<HookFormInputGroup
						name={ThirtyPlusDays.name}
						register={register}
						emptyLabel
						colInput={6}
						colLabel={4}
						validator={{
							maxValue100,
							required,
							validateDaysToDelivery,
						}}
						blurLoading={isLoading}
						autoComplete="off"
						normalize={onlyPercent}
						normalizeOnBlur={float2Normalizer}
						className={styles.inputGroup}
						onBlur={handleUpdateValue}
						errors={errors}
						addon="%"
					/>
				</Col>
			</Row>
		</>
	);
};
